module.exports = __webpack_public_path__ + "static/images/jcb.3z0DhpR.svg";